var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoneyFill = function SvgMoneyFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M7.581 20.75a1.75 1.75 0 0 1-1.581 1H4A1.75 1.75 0 0 1 2.25 20v-6c0-.966.784-1.75 1.75-1.75h2c.838 0 1.538.59 1.71 1.376l.69-.46a5.442 5.442 0 0 1 4.342-.754l2.292.573a2.264 2.264 0 0 1 1.716 2.197v.318l1.749-1.312a2.265 2.265 0 0 1 2.96 3.414l-2.073 2.072a4.753 4.753 0 0 1-2.427 1.3l-2.93.585c-.69.138-1.4.122-2.084-.05l-2.65-.661h-.002a3.208 3.208 0 0 0-.785-.098h-.927Zm4.728-.696c.467.117.954.129 1.426.035l2.93-.586a3.255 3.255 0 0 0 1.66-.89l2.074-2.072a.764.764 0 0 0-1-1.153L16.984 17.2c-.577.432-1.34.547-1.651.55H13a.75.75 0 0 1 0-1.5h1.485a.765.765 0 0 0 .765-.765v-.303a.764.764 0 0 0-.578-.741l-2.292-.573a3.94 3.94 0 0 0-3.146.545L7.75 15.4v3.849l3.049.427 1.51.377Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1E",
    fillRule: "evenodd",
    d: "M19.334 10h-8.667A1.666 1.666 0 0 1 9 8.334V3.667C9 2.746 9.746 2 10.666 2h8.667C20.254 2 21 2.746 21 3.667v4.666C21 9.254 20.254 10 19.334 10Zm-2.92-5.415a2.001 2.001 0 0 0-2.828 2.83 2 2 0 0 0 2.828-2.83Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoneyFill);
export default ForwardRef;